<template>
  <div v-if="props.type === 'image'" class="card">
    <!-- <img :src="props.imgUrl" :alt="props.imgDesk"> -->
    <SliderCardSwiper :swiperSlides="slider" :showNavigation="showNavigation" />
    <Play
      v-if="showVideo"
      @click="$emit('playVideo')"
      :btnClass="[props.btnPlayClass, 'product-card-play']"
    />
  </div>
  <div v-else-if="props.type === 'info'" class="card-info">
    <div class="card-info__image">
      <img :src="props.imgUrl" :alt="props.imgDesk" />
    </div>
    <div v-if="props.title.length > 0" class="card-info__title">
      {{ props.title }}
    </div>
    <div class="card-info__cost" v-if="price > 0">
      <span class="cost--old" v-if="priceOld > 0">{{ priceOld }}</span>
      <span class="cost">{{ price }}&nbsp;₽</span>
    </div>
  </div>
  <div v-else-if="props.type === 'image-video'" class="card-image pr">
    <img :src="props.imgUrl" :alt="props.imgDesk" />
    <Play
      v-if="showVideo"
      :btnClass="props.btnPlayClass"
      @click="$emit('playVideo')"
    />
  </div>
</template>

<script setup>
import SliderCardSwiper from "~/components/UI/Slider/SliderCardSwiper.vue";
import Play from "~/components/UI/btn/Play.vue";
import Zoom from "~/components/UI/btn/Zoom.vue";

const props = defineProps({
  type: {
    type: String,
    default: "image",
  },
  imgUrl: {
    type: String,
    default: "",
  },
  imgDesk: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  info: {
    type: String,
    default: "",
  },
  btnPlayClass: {
    type: String,
    default: "",
  },
  showVideo: {
    type: Boolean,
    default: false,
  },
  showZoom: {
    type: Boolean,
    default: true,
  },
  showNavigation: {
    type: Boolean,
    default: false,
  },
  slider: {
    type: Array,
    default: () => [],
  },
  price: {
    type: Number,
    default: 0,
  },
  priceOld: {
    type: Number,
    default: 0,
  },
});
</script>
